// removed by extract-text-webpack-plugin
module.exports = {"svg":"FNl8fO6oB446z9M4LDyXL"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/BottomBar/NextButton/styles.scss
 ** module id = 504
 ** module chunks = 0
 **/